<template lang="pug">
.columns(v-if="!loading")
  .divider.col-12
  .column.col-12
    .title
      .h3 Assinaturas
      button.btn.btn-primary(@click="subscriptionModalActive = true" type="button") Nova
    subscriptions-table(v-if="list" :subscriptions="list" @change-page="fetchData" @cancel-subscription="onCancelSubscription" @show-subscription="onShowSubscription")
    subscription-form(v-if="subscriptionModalActive" @close="subscriptionModalActive = false" @subscription-created="fetchData" :personId="$route.params.id")
</template>

<script>
import SubscriptionForm from './Form'
import SubscriptionsTable from './Table'
import subscriptionsServices from '@/services/subscriptions'

export default {
  data() {
    return {
      loading: false,
      list: null,
      subscriptionModalActive: false,
    }
  },

  components: { SubscriptionForm, SubscriptionsTable },

  async created() {
    this.loaded = true
    try {
      await this.fetchData(1)
    } catch (e) {
      this.$toaster.error('Error ao carregar lista de assinaturas do usuário')
    } finally {
      this.loaded = false
    }
  },

  methods: {
    async fetchData(page) {
      const { data } = await subscriptionsServices.list({
        q: {
          personId: this.$route.params.id,
        },
        take: 5,
        page,
      })
      this.list = data
    },

    async onCancelSubscription(subscriptionId) {
      const options = {
        size: 'sm',
        title: 'Confirmar cancelamento',
        okLabel: 'Sim',
        cancelLabel: 'Não',
      }
      const { ok } = await this.$dialogs.confirm(
        `Deseja cancelar a assinatura com ID: ${subscriptionId}?`,
        options,
      )

      if (!ok) return

      try {
        await subscriptionsServices.cancel(subscriptionId)
        await this.fetchData(1)
      } catch (e) {
        this.$toaster.error('Erro ao cancelar a assinatura')
      }
    },

    onShowSubscription(subscriptionId) {
      this.$router.push({
        name: 'subscriptions.show',
        params: { id: subscriptionId },
      })
    },
  },
}
</script>

<style lang="stylus" scoped>
.title
  display flex
  justify-content space-between
  align-align-items center
</style>
